<template>
    <div style="position: absolute; right: 16px; bottom: 8px;">
        <v-row class="ma-n4">
            <template v-if="isToolOn">
                <v-col class="pa-4">
                    <v-card flat rounded="xl">
                        <v-card-title class="px-16 py-0" style="height:36px">
                            <span class="page-text--sm">
                                {{ EMPLOYMENT_FIELD_SIDES[side]?.text }}
                                {{ EMPLOYMENT_FIELD_TYPES[type]?.text }}
                                추가하기
                            </span>
                        </v-card-title>
                    </v-card>
                </v-col>
                <v-col class="pa-4" cols="auto">
                    <v-btn icon color="black" class="white" @click="exit">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </template>
            <template v-else>
                <v-col class="pa-4" cols="auto">
                    <v-dialog v-model="shows" max-width="320" :close-on-content-click="false">
                        <template #activator="{ attrs, on }">
                            <v-btn icon color="white" class="primary" v-bind="attrs" v-on="on">
                                <v-icon> mdi-pencil </v-icon>
                            </v-btn>
                        </template>
                        <pages-side v-model="form" @input="emit" />
                    </v-dialog>
                </v-col>
            </template>
        </v-row>
    </div>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES, initEmploymentForm } from "@/assets/variables";

import PagesSide from "./pages-side.vue";
import { mapGetters, mapState } from "vuex";

export default {
    components: {
        PagesSide,
    },
    props: {
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),

        shows: false,

        EMPLOYMENT_FIELD_SIDES,
        EMPLOYMENT_FIELD_TYPES,
    }),
    computed: {
        ...mapGetters("employment/form/tool", { isToolOn: "isOn" }),
        ...mapState("employment/form/tool", ["side", "type"]),
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        side(side) {
            if (side) this.shows = !this.isToolOn;
        },
        type(type) {
            if (type) this.shows = !this.isToolOn;
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        exit() {
            this.$store.commit("employment/form/tool/init");
        },
    },
};
</script>

<style></style>
